/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientResource } from './';
import {
    ClientResourceFromJSON,
    ClientResourceFromJSONTyped,
    ClientResourceToJSON,
} from './';
import type { ReferredProjectResource } from './';
import {
    ReferredProjectResourceFromJSON,
    ReferredProjectResourceFromJSONTyped,
    ReferredProjectResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReferralResource
 */
export interface ReferralResource {
    /**
     * 
     * @type {string}
     * @memberof ReferralResource
     */
    referralId: string;
    /**
     * Company's name proposing the project linked to the referral
     * @type {string}
     * @memberof ReferralResource
     */
    companyName: string;
    /**
     * 
     * @type {ClientResource}
     * @memberof ReferralResource
     */
    client?: ClientResource;
    /**
     * Referrer account identifier
     * @type {string}
     * @memberof ReferralResource
     */
    referrerAccountId: string;
    /**
     * Referrer identity identifier
     * @type {string}
     * @memberof ReferralResource
     */
    referrerIdentityId: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralResource
     */
    referrerEmail?: string;
    /**
     * only for Malt Admin
     * @type {string}
     * @memberof ReferralResource
     */
    repatriationOpportunityId?: string;
    /**
     * only for Malt Admin
     * @type {string}
     * @memberof ReferralResource
     */
    sourcingOpportunityId?: string;
    /**
     * Opportunity's title linked to the referral
     * @type {string}
     * @memberof ReferralResource
     */
    opportunityTitle: string;
    /**
     * Date of the referral submission
     * @type {Date}
     * @memberof ReferralResource
     */
    submissionDate: Date;
    /**
     * Referral's percentage
     * @type {number}
     * @memberof ReferralResource
     */
    rewardPercentage: number;
    /**
     * Are multiple freelancers working on a project originated from this referral
     * @type {boolean}
     * @memberof ReferralResource
     */
    multipleFreelancersReferred: boolean;
    /**
     * List of projects started from this referral
     * @type {Array<ReferredProjectResource>}
     * @memberof ReferralResource
     */
    referredProjects: Array<ReferredProjectResource>;
    /**
     * Has the referral been cancelled
     * @type {boolean}
     * @memberof ReferralResource
     */
    isCancelled: boolean;
    /**
     * Has the referral expired (1 year after submission)
     * @type {boolean}
     * @memberof ReferralResource
     */
    isExpired: boolean;
}

/**
 * Check if a given object implements the ReferralResource interface.
 */
export function instanceOfReferralResource(value: object): value is ReferralResource {
    if (!('referralId' in value) || value['referralId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('referrerAccountId' in value) || value['referrerAccountId'] === undefined) return false;
    if (!('referrerIdentityId' in value) || value['referrerIdentityId'] === undefined) return false;
    if (!('opportunityTitle' in value) || value['opportunityTitle'] === undefined) return false;
    if (!('submissionDate' in value) || value['submissionDate'] === undefined) return false;
    if (!('rewardPercentage' in value) || value['rewardPercentage'] === undefined) return false;
    if (!('multipleFreelancersReferred' in value) || value['multipleFreelancersReferred'] === undefined) return false;
    if (!('referredProjects' in value) || value['referredProjects'] === undefined) return false;
    if (!('isCancelled' in value) || value['isCancelled'] === undefined) return false;
    if (!('isExpired' in value) || value['isExpired'] === undefined) return false;
    return true;
}

export function ReferralResourceFromJSON(json: any): ReferralResource {
    return ReferralResourceFromJSONTyped(json, false);
}

export function ReferralResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralResource {
    if (json == null) {
        return json;
    }
    return {
        
        'referralId': json['referralId'],
        'companyName': json['companyName'],
        'client': json['client'] == null ? undefined : ClientResourceFromJSON(json['client']),
        'referrerAccountId': json['referrerAccountId'],
        'referrerIdentityId': json['referrerIdentityId'],
        'referrerEmail': json['referrerEmail'] == null ? undefined : json['referrerEmail'],
        'repatriationOpportunityId': json['repatriationOpportunityId'] == null ? undefined : json['repatriationOpportunityId'],
        'sourcingOpportunityId': json['sourcingOpportunityId'] == null ? undefined : json['sourcingOpportunityId'],
        'opportunityTitle': json['opportunityTitle'],
        'submissionDate': (new Date(json['submissionDate'])),
        'rewardPercentage': json['rewardPercentage'],
        'multipleFreelancersReferred': json['multipleFreelancersReferred'],
        'referredProjects': ((json['referredProjects'] as Array<any>).map(ReferredProjectResourceFromJSON)),
        'isCancelled': json['isCancelled'],
        'isExpired': json['isExpired'],
    };
}

export function ReferralResourceToJSON(value?: ReferralResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'referralId': value['referralId'],
        'companyName': value['companyName'],
        'client': ClientResourceToJSON(value['client']),
        'referrerAccountId': value['referrerAccountId'],
        'referrerIdentityId': value['referrerIdentityId'],
        'referrerEmail': value['referrerEmail'],
        'repatriationOpportunityId': value['repatriationOpportunityId'],
        'sourcingOpportunityId': value['sourcingOpportunityId'],
        'opportunityTitle': value['opportunityTitle'],
        'submissionDate': ((value['submissionDate']).toISOString().substring(0,10)),
        'rewardPercentage': value['rewardPercentage'],
        'multipleFreelancersReferred': value['multipleFreelancersReferred'],
        'referredProjects': ((value['referredProjects'] as Array<any>).map((v) => ReferredProjectResourceToJSON(v))),
        'isCancelled': value['isCancelled'],
        'isExpired': value['isExpired'],
    };
}

